import React from 'react';
import PropTypes from 'prop-types';
import s from './SignalTranslationEquationList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

const SignalTranslationEquationListTable = ({ paginatedData = [], UpdateAllowed, currentTimezone, ModelCategoryId, IsModelCategoryOwner }) => {
  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="signalTranslationEquation.name" defaultMessage="Name" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="signalTranslationEquation.formula" defaultMessage="Formula" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="signalTranslationEquation.description" defaultMessage="Description" />
            </th>

            <th></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <tr key={n.SignalTranslationEquationId} data-unittest="signalTranslationEquationData">
                <td>{n.Name || ''}</td>
                <td>{n.Formula || ''}</td>
                <td className="d-none d-md-table-cell">{n.Description || ''}</td>
                <td>
                  {IsModelCategoryOwner && UpdateAllowed ? (
                    <Link to={`/operational-setup/model-category-configuration/${ModelCategoryId}/signal-translation-equation/${n.SignalTranslationEquationId}`}>
                      <Button variant="outline-secondary" className={s.changeButton}>
                        <FormattedMessage id="common.edit" defaultMessage="EDIT" />
                      </Button>
                    </Link>
                  ) : null}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};



SignalTranslationEquationListTable.propTypes = {
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(SignalTranslationEquationListTable);
